import React, { Component } from "react";
import "./end.css";

export class End extends Component {
  /* Focus on content for keyboard scrolling */
  boxContent = React.createRef();
  componentDidMount() {
    this.boxContent.current.focus();
  }

  render() {
    return (
      <div className="box-content" ref={this.boxContent} tabIndex="-1">
        <div className="d-flex medium-font text-block">
          <span className="d-flex medium-font large-text">
            Merci pour vos renseignements
          </span>

          <div className="d-flex large-text medium-font wrapper">
            <span>Nous allons vous contacter&nbsp;</span>
            <span>très rapidement pour&nbsp;</span>
            <span>planifier un RDV.</span>
          </div>

          <div className="d-flex large-text medium-font wrapper">
            <span>Nous serons ravis d'échanger&nbsp;</span>
            <span>sur ce sujet passionnant !</span>
          </div>

          <span
            className="d-flex medium-font p-tag p-tag-rounded large-text-tag"
            style={{ marginTop: "25px" }}
          >
            A très bientôt
          </span>

          <a className="link" href="https://www.groupe-creative.fr/">
            https://www.groupe-creative.fr/
          </a>
        </div>
      </div>
    );
  }
}
